module.exports = ".side-header[_ngcontent-c1] {\r\n  min-height: 40px;\r\n  height: 60px;\r\n  padding: 4px 13px;\r\n}\r\n.nav-name {\r\n  cursor: pointer;\r\n}\r\n.nav-main a.nav-submenu {\r\n  cursor: pointer;\r\n}\r\n.not-allowed {\r\n  cursor: not-allowed;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/nav-left/nav-left.component.css
// module id = ./src/app/components/nav-left/nav-left.component.css
// module chunks = main